import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import Logger from '/@/modules/core/app/helpers/Logger';

export class BaseSocketEvent extends BaseModel {
  /**
   * @var {string}
   */
  className;

  /**
   * @var {string}
   */
  name;

  constructor(model = {}) {
    super();

    this.className = model.className;
    this.name = model.name;
  }

  /**
   * @param {AuthUser} authUser
   * @param {number|string|undefined} identifier
   * @returns {?string}
   */
  static getChannelName(authUser, identifier) {
    Logger.error('Declare this method in socket event class');
  }

  /**
   * @returns {string}
   */
  static getEventName() {
    Logger.error('Declare this method in socket event class');
  }

  /**
   * @returns {string}
   */
  static getEchoEventName() {
    return `.${this.getEventName()}`;
  }
}
